<div class="card">
  <app-header titulo="Responsável x Depósito" descricao="Configuração dos responsaveis por depósito"></app-header>

  <p-table [value]="registros" dataKey="id" [loading]="loading" #dt
           [lazy]="true" (onLazyLoad)="onLazyLoad($event)"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
           [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
           [totalRecords]="totalRecords"
           currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
    <ng-template pTemplate="caption">
      <div class="flex">
        <button pButton icon="pi pi-plus" label="Novo Cadastro" class="p-button-success"
                routerLink="novo"></button>
        <span class="ml-auto">
          <button pButton pRipple icon="pi pi-refresh" (click)="recarregar()" [loading]="loading"></button>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="id">ID <p-sortIcon field="id"/></th>
        <th pSortableColumn="codigoFuncionario">Cód. Funcionário <p-sortIcon field="codigoFuncionario"/></th>
        <th pSortableColumn="codigoDepositoOrigem">Depósito Origem <p-sortIcon field="codigoDepositoOrigem"/></th>
        <th pSortableColumn="codigoDepositoDestino">Depósito Destino <p-sortIcon field="codigoDepositoDestino"/></th>
        <th>Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-registro>
      <tr>
        <td>{{ registro.id }}</td>
        <td>{{ registro.codigoFuncionario }}</td>
        <td>{{ registro.codigoDepositoOrigem }}</td>
        <td>{{ registro.codigoDepositoDestino }}</td>
        <td>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                  [routerLink]="['editar', registro.id]"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                  (click)="confirmarExclusao(registro)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">Nenhum registro encontrado</td>
      </tr>
    </ng-template>
  </p-table>

  <p-confirmDialog header="Confirmação" width="425"></p-confirmDialog>
</div>
